module.exports = __webpack_public_path__ + "images/logo-tagline.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo-tagline.png
 ** module id = 177
 ** module chunks = 0
 **/